import { Paper, alpha, Box, Icon, Typography } from "@mui/material";
import React from "react";
import { theme } from "../../../theme";

export const POSDashboardCard: React.FC<{
  color: string;
  value: string;
  icon: React.ReactNode;
  description: string;
  title: string;
}> = ({ color, value, icon, description, title }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        backgroundColor: alpha(theme.palette.background.paper, 0.8),
        backdropFilter: "blur(8px)",
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: theme.shadows[4],
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: alpha(color, 0.1),
          }}
        >
          <Icon
            sx={{
              color: color,
              fontSize: 24,
            }}
          >
            {icon}
          </Icon>
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 0.5 }}>
            {title}
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {value}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="caption"
        sx={{ color: "text.secondary", mt: "auto" }}
      >
        {description}
      </Typography>
    </Paper>
  );
};
